import { render, staticRenderFns } from "./veStuAssocFundsStandardShow.vue?vue&type=template&id=f7a673ae&scoped=true"
import script from "./veStuAssocFundsStandardShow.vue?vue&type=script&lang=js"
export * from "./veStuAssocFundsStandardShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a673ae",
  null
  
)

export default component.exports